import {NgModule} from "@angular/core";

import {FooterLinksComponent} from '@core-components/footer/footer-links/footer-links.component';
import {PrivacyPolicyComponent} from "@core-components/footer/privacy-policy/privacy-policy.component";
import {TermsAndConditionsComponent} from "@core-components/footer/terms-and-conditions/terms-and-conditions.component";
import {
  NotificationsDialogComponent
} from "@core-components/notifications/notifications-dialog/notifications-dialog.component";
import {NotificationsComponent} from "@core-components/notifications/notifications.component";
import {BasePageComponent} from '@core-components/page-content/base-page.component';
import {PageHeaderComponent} from "@core-components/page-header/page-header.component";
import {PageNotFoundComponent} from '@core-components/page-not-found/page-not-found.component';
import {PageTabContentComponent} from '@core-components/page-tab-content/page-tab-content.component';
import {PageTabNavigatorComponent} from '@core-components/page-tab-navigator/page-tab-navigator.component';
import {
  PasswordChangeOtpDialogComponent
} from '@core-components/user-profile-popover/dialogs/password-change-otp-dialog/password-change-otp-dialog.component';
import {
  UploadUserProfileImageComponent
} from '@core-components/user-profile-popover/dialogs/upload-user-profile-image/upload-user-profile-image.component';
import {
  UserProfileDialogComponent
} from '@core-components/user-profile-popover/dialogs/user-profile-dialog/user-profile-dialog.component';
import {UserProfilePopoverComponent} from '@core-components/user-profile-popover/user-profile-popover.component';
import {BaseTemplateBuilderComponent} from "@features/internal/base-template-builder/base-template-builder.component";
import {
  EmailTemplateDesignerComponent
} from "@features/settings/template-builder/email-template-designer/email-template-designer.component";
import {AppSharedModule} from "@modules/app-shared.module";
import {MaterialModule} from "@modules/material.module";

import {HeaderLessTabDirective} from '../../core/directives/header-less-tab.directive';
import {AngularModule} from "./angular.module";


const components = [
  BasePageComponent,
  FooterLinksComponent,
  HeaderLessTabDirective,
  NotificationsComponent,
  NotificationsComponent,
  NotificationsDialogComponent,
  PageHeaderComponent,
  PageNotFoundComponent,
  PageTabContentComponent,
  PageTabNavigatorComponent,
  PasswordChangeOtpDialogComponent,
  PrivacyPolicyComponent,
  TermsAndConditionsComponent,
  TermsAndConditionsComponent,
  UploadUserProfileImageComponent,
  UserProfileDialogComponent,
  UserProfileDialogComponent,
  UserProfilePopoverComponent,
  UserProfilePopoverComponent,
  EmailTemplateDesignerComponent,
  BaseTemplateBuilderComponent,
];

// const modules = [
//   // EmailEditorModule,
//   ]

@NgModule({
  imports: [
    MaterialModule,
    AppSharedModule,
    AngularModule
  ],
  declarations: [...components],
  exports: [
    AngularModule,
    AppSharedModule,
    ...components,
    // ...modules
  ]
})
export class AppCoreModule {
}
